<template>
  <path pid="0" d="M22.79 3.3L12.5 13.59l-2.29-2.29a1 1 0 00-1.42 0 1 1 0 000 1.41l3 3a1 1 0 001.42 0l11-11a1 1 0 000-1.41 1 1 0 00-1.42 0z"/><path pid="1" d="M15.62 23.55A11 11 0 0023.5 13v-.93a1 1 0 10-2 0V13a9 9 0 11-5.34-8.23A1 1 0 0017 3a11 11 0 10-1.36 20.6z"/>
</template>
